import React, { createContext } from 'react';
import { TrackingEvent } from '@/shared/domain/models';

export type TrackingDispatchEvent = Omit<TrackingEvent, 'appName' | 'timestamp'>;

type TrackingContextProps = {
  appName: string;
  onDispatch: (trackingEvent: TrackingEvent) => void;
};

type TrackingProviderProps = TrackingContextProps & {
  children: React.ReactElement;
};

export const TrackingContext = createContext<TrackingContextProps | undefined>(undefined);

export const TrackingProvider = ({ appName, onDispatch, children }: TrackingProviderProps) => {
  const value = { appName, onDispatch };
  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
};
